import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { LoaderService } from '../../shared/loader/loader.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Router } from '@angular/router';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/internal/Observable';
import { map, startWith } from 'rxjs/operators';
import { MessageTemplate, RequestType } from '../Enum/common.enum';

export interface State {
  name: string;
  fax: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-email-File',
  templateUrl: './email-File.component.html',
  styleUrls: ['./email-File.component.scss']
})

export class EmailFileComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;


  contactsList: any = [];
  peoples: any = [];
  showAddButton = false;
  Module: string;

  closeShare: boolean = false;
  @Input() mainModuleName: string;
  @Output() closeShareFile = new EventEmitter<boolean>();
  clickEventsubscription: any;
  selectedFileList: any = [];
  timeout = null;
  subject: string = "";
  message: string = "";
  replyFaxNumber: string = "";
  fileManagerIDs: any[];
  contacts: any;
  FileList: any[]=[];
  UserList: any = [];

  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  roleInputCurrentvalue: any;
  stateCtrSendlValue: any;

  stateCtrlValue: string;
  objectList: any = [];
  contactFax: any;
  transactionID: any;
  addButtonShow: boolean = false;
  anonymousFax: any = [] = [];
  spinner:boolean=false;
  OfficeIDList: any = [];
  myOfficeID: any;
  spinnerTemp:boolean=false;

  stateCtrlSubject = new FormControl();
  filteredStates1: Observable<any[]>;

  constructor(private loaderService: LoaderService,private cdr: ChangeDetectorRef,private _dataSharingService: DataSharingService,
    private router: Router,private reusableClass: ReusableClasses,private encryptionAlgo: EncryptionService,
    private statusConst: StatusConstant,private settingsService: SettingService,private toastr: ToastrService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''), map((state) => (state ? this._filterStates(state) : this.states.slice())));
  }

  states = this.objectList;

  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();
    return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.mainModuleName;
  }


  ngOnInit(): void {
    this.mainModuleName;
    // this.clickEventsubscription = this._dataSharingService.getSelectedRequestDocumentForCore().subscribe((result) => {
    //   if (result) {
    //     this.mainModuleName;
    //     this.selectedFileList = result;
    //     this.showAddButton = false;
    //     this.stateCtrlSubject.reset();
    //     this.ShowSubjectMessageButton=false;
    //     this.MessageTemplateID=0;
    //   }
    // });

    // this.clickEventsubscription = this._dataSharingService.getSelectedRequestDocumentForContact().subscribe((result) => {
    //   if (result) {
    //     this.mainModuleName;
    //     this.selectedFileList = result;
    //     this.showAddButton = false;
    //     this.stateCtrlSubject.reset();
    //     this.ShowSubjectMessageButton=false;
    //     this.MessageTemplateID=0;
    //   }
    // });

    // this.clickEventsubscription = this._dataSharingService.getSelectedRequestDocumentForCompany().subscribe((result) => {
    //   if (result) {
    //     this.mainModuleName;
    //     this.selectedFileList = result;
    //     this.showAddButton = false;
    //     this.stateCtrlSubject.reset();
    //     this.ShowSubjectMessageButton=false;
    //     this.MessageTemplateID=0;
    //   }
    // });

    this.clickEventsubscription = this._dataSharingService.getSelectedFaxDocumentForFileManager().subscribe((result) => {
      if (result) {
        this.mainModuleName;
        this.selectedFileList = result;
        this.showAddButton = false;      
      }
    });
  }

  closeShareOpt(message: boolean) {
    this.showAddButton = false;
    this.selectedAssignedTo=[];   
    this.closeShareFile.emit(message);
  }

  cancelShareOpt(message: boolean) {
    this.showAddButton = false;  
    this.selectedAssignedTo=[];
    this.closeShareFile.emit(message);
    //this.subject = "";
    //this.message = "";
    //this.replyFaxNumber = "";
    //this.stateCtrl.reset();
    //this.stateCtrlSubject.reset();
    //this.MessageTemplateID=0;
    // if (this.mainModuleName == "Core") {
    //   this._dataSharingService.sendClosePanelFromDocDetailsCore(true);
    // }
    // if (this.mainModuleName == "Contact") {
    //   this._dataSharingService.sendClosePanelFromDocDetailsContact(true);
    // }
    // if (this.mainModuleName == "Company") {
    //   this._dataSharingService.sendClosePanelFromDocDetailsCompany(true);
    // }
    if (this.mainModuleName == "File Manager") {
      this._dataSharingService.sendClosePanelFaxForFileManager(true);
    }
  }

  getplaceholdername(placeholdername) {
    if(placeholdername!=null && placeholdername!=undefined){
      var x = placeholdername;
      var f = x.replace(/\..+$/, '');
      return f;
    }   
  }


  removeDocument(document) {
    const index = this.selectedFileList.indexOf(document);
    if (index >= 0) {
      this.selectedFileList.splice(index, 1);
      if (this.mainModuleName == "Core") {
        this._dataSharingService.sendRemoveFaxDocumentForCore(document);
      }
      if (this.mainModuleName == "Contact") {
        this._dataSharingService.sendRemoveRequestDocumentForContact(document);
      }
      if (this.mainModuleName == "Company") {
        this._dataSharingService.sendRemoveRequestDocumentForCompany(document);
      }
      if (this.mainModuleName == "File Manager") {
        this._dataSharingService.sendRemoveFaxDocumentForFileManager(document);
      }
    }
    if (this.selectedFileList.length == 0) {
      this.showAddButton = false;
      this.closeShareOpt(false);
      if (this.mainModuleName == "Core") {
        this._dataSharingService.sendRemoveFaxDocumentForCore(true);
      }
      if (this.mainModuleName == "Contact") {
        this._dataSharingService.sendClosePanelFromDocDetailsContact(true);
      }
      if (this.mainModuleName == "Company") {
        this._dataSharingService.sendClosePanelFromDocDetailsCompany(true);
      }
      if (this.mainModuleName == "File Manager") {
        this._dataSharingService.sendClosePanelFaxForFileManager(true);
      }
    }
  }  

  sendEmail() {   
    this.showAddButton=false;
    this.spinner=true;
    var emails:string="";
    this.selectedFileList;    
    this.FileList = [];
    if (this.selectedAssignedTo.length > 0) {
      for (let i = 0; i < this.selectedAssignedTo.length; i++) {       
        emails+= this.selectedAssignedTo[i].email+',';
      }     
    }
    if (this.selectedFileList.length > 0) {
      this.transactionID = this.selectedFileList[0].transactionID;
      for (let i = 0; i < this.selectedFileList.length; i++) {       
        let file = {
          docName: this.selectedFileList[i].name,
          docUrl: this.selectedFileList[i].azureblobPath,        
        }
        this.FileList.push(file);
      }
    } else {
      this.FileList = [];
    }
    emails = emails.replace(/,*$/, '');
    var reqModel = {
      documents:this.FileList,
      emails: emails,
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId),
      officeID:this.myOfficeID,
    }
    //return;
    this.settingsService.sendFilemanagerDocuments(reqModel).subscribe(response => {
      if (response != undefined) {
        this.spinner=false;
        this.closeShareOpt(false);
        if (response.status == this.statusConst.statusSuccess) {         
          this.toastr.success('Mail send successfully.', '', {
            timeOut: 3000,
          });        
          this._dataSharingService.sendClosePanelFaxForFileManager(true);
        }
        else {
          this.spinner=false;       
          this.toastr.error('Mail send failed.', '', {
            timeOut: 3000,
          });
          this.closeShareOpt(false);
          this._dataSharingService.sendClosePanelFaxForFileManager(true);
        }
      } else {       
        this.spinner=false;       
        this.toastr.error('Mail send failed.', '', {
          timeOut: 3000,
        });
        this.closeShareOpt(false);
        this._dataSharingService.sendClosePanelFaxForFileManager(true);
      }
    });

  }

  /** Allow only Alphabet */
  allowAlphabetOnly(event) {
		const regexp = new RegExp('^[0-9!@#$&()\\-`.+,/\"]*$');
		const result = regexp.test(event.key);
		if (result) {
      //this.titleAlert = 'Please enter only alphabets';
		  event.preventDefault();
		  return false;
		}
  }

  /** Allow only Number */
  allowOnlyNumber(event) {
		const regexp = new RegExp('^([0-9])$');
		const result = regexp.test(event.key);
		if (!result) {
		  event.preventDefault();
		  return false;
		}
  }


  ShowSubjectMessageButton:boolean=false;
  SubjectMessageButton:boolean=false;
  MessageTemplateID:number=0;

 
// ======================= Email ===============================//

selectedEmail: any = [] = [];
emailAssigned: string = "";

addEmailButtonShow :boolean=false;
selectedAssignedTo: any = [] = [];

emailCheck(searchValue: any) {
  if (searchValue.toLowerCase() == searchValue.toLowerCase().match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')) {
    this.emailAssigned = searchValue;
    this.addEmailButtonShow = true;
  } else {
    this.addEmailButtonShow = false;
  }
}

addEmail() { 
  var check = [];
  check = this.selectedAssignedTo.filter((x:any) => x.email.toLowerCase() == this.emailAssigned.toLowerCase());
  let toArray =  this.emailAssigned.split("@");
  var shortName = toArray[0].match(/\b(\w)/g).join('');    
  if (check.length == 0) {
    var obj={     
      email: this.emailAssigned,     
      img: "",
      shortName:shortName
    }
    this.selectedAssignedTo.push(obj);   
  
    // if(this.emailAssigned!=""){ 
    //   // email+= this.emailAssigned+',';
    // }
    this.emailAssigned = "";
    this.addEmailButtonShow = false;    
  } else {
    this.emailAssigned = "";
    this.addEmailButtonShow = false;
    this.toastr.warning('Email allready added.', '', {
      timeOut: 3000,
    });
 }  

 if(this.selectedAssignedTo.length>0){
   this.showAddButton=true;
   }else{
   this.showAddButton=false;
  }
}


removeEmail(item: any) {
  const index = this.selectedAssignedTo.indexOf(item);
  if (index >= 0) {
    this.selectedAssignedTo.splice(index, 1);
  }
  if(this.selectedAssignedTo.length>0){
    this.showAddButton=true;
  }else{
    this.showAddButton=false;
  }
}
  
 






}
